import { parkingRateListViewFiltersReceived } from "./../../actions/regulation/EditParkingRates/index";
import {
    DeleteParkingRateEditBatchAction,
    GET_PARKING_RATE_LIST_VIEW_FILTERS,
    GetParkingRateListViewFiltersAction,
    ParkingRateListViewFiltersReceivedAction,
    ProposedParkingRateRegulationsReceivedAction,
    ProposedParkingRateRegulationsRecords
} from "./../../actions/regulation/EditParkingRates/types";
import {
    getAllProposedParkingRateRegulations as getAllProposedParkingRateRegulationsAction,
    proposedParkingRateRegulationsReceived
} from "./../../actions/regulation/EditParkingRates";
import {
    DELETE_PARKING_RATE_EDIT_BATCH,
    GET_ALL_PROPOSED_PARKING_RATE_REGULATIONS,
    GetAllProposedParkingRateRegulationsAction
} from "../../actions/regulation/EditParkingRates/types";
import axios, { AxiosResponse } from "axios";
import { PutEffect, put, takeLatest } from "redux-saga/effects";
import { store } from "../../store";

function* getAllProposedParkingRateRegulations(
    action: GetAllProposedParkingRateRegulationsAction
): Generator<
    | Promise<ProposedParkingRateRegulationsReceivedAction>
    | PutEffect<{ payload: ProposedParkingRateRegulationsReceivedAction["payload"]; type: string }>,
    void,
    AxiosResponse<
        ProposedParkingRateRegulationsReceivedAction["payload"]["proposedParkingRateRegulations"]
    >
> {
    let url = "/api/batchregulations/?";
    Object.keys(action.payload.params).forEach((prop: string) => {
        if (Array.isArray(action.payload.params[prop])) {
            if (action?.payload?.params[prop]) {
                let allFilters = action.payload.params[prop]?.toString();
                url += `&${prop}=${allFilters}`;
            }
        } else {
            url += `&${prop}=${action.payload.params[prop]}`;
        }
    });
    const json = yield axios.get(url);
    yield put(
        proposedParkingRateRegulationsReceived({
            proposedParkingRateRegulations: json.data
        })
    );
}

export function* getAllProposedParkingRateRegulationsSaga() {
    yield takeLatest(
        GET_ALL_PROPOSED_PARKING_RATE_REGULATIONS,
        getAllProposedParkingRateRegulations
    );
}

function* deleteParkingRateEditBatch(action: DeleteParkingRateEditBatchAction) {
    try {
        yield axios.delete(`/api/batchregulations/${action.payload.id}`);

        if (action.payload.afterDelete) {
            action.payload.afterDelete();
        } else {
            yield put(
                getAllProposedParkingRateRegulationsAction({
                    params: store.getState().editParkingRates.proposedParkingRateRegulationsParams
                })
            );
        }
    } catch (err) {
        yield put(
            getAllProposedParkingRateRegulationsAction({
                params: store.getState().editParkingRates.proposedParkingRateRegulationsParams
            })
        );
    }
}

export function* deleteParkingRateEditBatchSaga() {
    yield takeLatest(DELETE_PARKING_RATE_EDIT_BATCH, deleteParkingRateEditBatch);
}

function* getParkingRateListViewFilters(
    action: GetParkingRateListViewFiltersAction
): Generator<
    | Promise<ParkingRateListViewFiltersReceivedAction>
    | PutEffect<{ payload: ParkingRateListViewFiltersReceivedAction["payload"]; type: string }>,
    void,
    ParkingRateListViewFiltersReceivedAction["payload"]
> {
    const json = yield axios.get("/api/batchregulations/batch_regulation_list_data/", {
        params: action.payload.params
    });
    yield put(
        parkingRateListViewFiltersReceived({
            data: json.data
        })
    );
}

export function* getParkingRateListViewFiltersSaga() {
    yield takeLatest(GET_PARKING_RATE_LIST_VIEW_FILTERS, getParkingRateListViewFilters);
}
